import React, {FC} from 'react';

import collectOpen from 'assets/v3/guide/extension/collect-open.webp';
import collectSelect from 'assets/v3/guide/extension/collect-select.webp';
import collectTranslate1 from 'assets/v3/guide/extension/collect-translate-1.webp';
import collectTranslate2 from 'assets/v3/guide/extension/collect-translate-2.webp';
import devMode from 'assets/v3/guide/extension/dev-mode.webp';
import downloadImg from 'assets/v3/guide/extension/download.webp';
import listingCollect from 'assets/v3/guide/extension/listing-collect.webp';
import listingDownload from 'assets/v3/guide/extension/listing-download.webp';
import listingOpen from 'assets/v3/guide/extension/listing-open.webp';
import listingParse from 'assets/v3/guide/extension/listing-parse.webp';
import listingPreview from 'assets/v3/guide/extension/listing-preview.webp';
import listingSelect from 'assets/v3/guide/extension/listing-select.webp';
import listingSettings from 'assets/v3/guide/extension/listing-settings.webp';
import loadUnpacked from 'assets/v3/guide/extension/load-unpacked.webp';
import pinFloat from 'assets/v3/guide/extension/pin-float.webp';
import pinToolbar from 'assets/v3/guide/extension/pin-toolbar.webp';
import refine1 from 'assets/v3/guide/extension/refine-1.webp';
import refine2 from 'assets/v3/guide/extension/refine-2.webp';
import storeInstall from 'assets/v3/guide/extension/store-install.webp';
import unzipMac from 'assets/v3/guide/extension/unzip-mac.webp';
import unzipWin from 'assets/v3/guide/extension/unzip-win.webp';
import unzippedFiles from 'assets/v3/guide/extension/unzipped-files.webp';

/** 사용 가이드「브라우저 확장 프로그램」탭 한국어 본문(zh.tsx와 요소 구조 1:1) — 2026-09-17 AI 번역 */
const KoContent: FC = () => {
  return (
    <>
      <h2>Chrome 등 브라우저에 확장 프로그램을 설치하는 방법</h2>

      <h3>방법 1: Chrome 웹 스토어에서 설치</h3>
      <p>
        공식 Chrome 웹 스토어에서 설치하려면 먼저 네트워크가 Google 서비스에 접속할 수 있어야 해요(프록시 도구가
        필요해요).
      </p>
      <ul>
        <li>
          확장 프로그램 다운로드 링크로 바로 이동하세요:
          <br />
          <a
            href="https://chromewebstore.google.com/detail/%E8%B1%A1%E5%AF%84%E5%9B%BE%E7%89%87%E7%BF%BB%E8%AF%91%E5%8A%A9%E6%89%8B/ejkpocbmomaefkinmkfbfnpjjfbinegb?utm_source=xj-doc"
            rel="noreferrer"
            target="_blank"
          >
            <span aria-hidden="true">🔗</span> Chrome 웹 스토어에서 설치
          </a>
        </li>
        <li>오른쪽 상단의 “Chrome에 추가” 버튼을 클릭하면 설치가 완료돼요.</li>
      </ul>
      <img alt="Chrome 웹 스토어에서 설치" decoding="async" loading="lazy" src={storeInstall} />

      <h3>방법 2: 설치 패키지를 다운로드해 수동 설치</h3>
      <p>
        1. 아래 zip 패키지를 클릭해 최신 버전 확장 프로그램을 다운로드하세요:
        <br />
        <a href="https://i.tosoiot.com/assets/xj-chrome-ext.zip" rel="noreferrer" target="_blank">
          <span aria-hidden="true">📥</span> 브라우저 확장 프로그램 다운로드
        </a>
      </p>
      <p>2. 다운로드가 끝나면 파일의 압축을 풀어 주세요. .zip 파일이며, 압축을 풀면 폴더 하나가 나와요.</p>
      <p>macOS</p>
      <img alt="macOS에서 압축을 푼 폴더" decoding="async" loading="lazy" src={unzipMac} />
      <p>Windows</p>
      <img alt="Windows에서 압축을 푼 폴더" decoding="async" loading="lazy" src={unzipWin} />
      <p>폴더 안에는 아래 파일들이 들어 있어요:</p>
      <img alt="확장 프로그램 폴더 내용" decoding="async" loading="lazy" src={unzippedFiles} />
      <p>3. Chrome의 “확장 프로그램 관리” 페이지를 열어 주세요.</p>
      <ul>
        <li>방법 1: 주소창에 chrome://extensions/를 입력하세요</li>
        <li>방법 2: 오른쪽 상단의 브라우저 메뉴를 클릭하고 설정을 연 뒤 확장 프로그램을 찾으세요</li>
      </ul>
      <p>오른쪽 상단에서 “개발자 모드”를 켜세요.</p>
      <img alt="개발자 모드 켜기" decoding="async" loading="lazy" src={devMode} />
      <p>
        4. “압축해제된 확장 프로그램 로드”를 클릭하세요. 대화상자에서 방금 압축을 푼 폴더를 선택하고 확인하면 확장
        프로그램 가져오기가 완료돼요.
      </p>
      <img alt="압축해제된 확장 프로그램 로드" decoding="async" loading="lazy" src={loadUnpacked} />
      <p>
        가져오기가 끝나면 확장 프로그램을 툴바에 고정하고 플로팅 위젯을 켜 두면 더 편하게 사용할 수 있어요. 페이지를
        새로고침하면 바로 이미지 수집을 시작할 수 있어요.
      </p>
      <img alt="확장 프로그램을 툴바에 고정" decoding="async" loading="lazy" src={pinToolbar} />
      <img alt="플로팅 위젯" decoding="async" loading="lazy" src={pinFloat} />

      <h2>확장 프로그램으로 이미지를 수집해 번역하는 방법</h2>

      <h3>1. 번역할 상품 페이지를 열어 주세요</h3>
      <img alt="번역할 상품 페이지 열기" decoding="async" loading="lazy" src={collectOpen} />

      <h3>2. 【이미지 번역】을 선택하고 상품 이미지를 수집하세요</h3>
      <p>확장 프로그램 아이콘이나 플로팅 위젯을 클릭해 【이미지 번역】을 선택한 뒤 상품 이미지를 수집하세요.</p>
      <img alt="번역 유형 선택" decoding="async" loading="lazy" src={collectSelect} />
      <p>번역할 이미지를 필요에 따라 선택하고, 대상 언어를 고른 뒤 【번역】을 클릭하면 상품 이미지 번역이 시작돼요.</p>
      <img alt="번역할 상품 컷 선택" decoding="async" loading="lazy" src={collectTranslate1} />
      <img alt="수집한 이미지 번역 시작" decoding="async" loading="lazy" src={collectTranslate2} />

      <h3>3. 번역한 이미지를 다운로드하거나 보정하세요</h3>
      <p>이미지를 클릭하면 크게 확대해 번역 상태를 확인할 수 있어요. 만족스러우면 기기로 한꺼번에 다운로드하세요.</p>
      <img alt="번역 결과 확인 후 일괄 다운로드" decoding="async" loading="lazy" src={downloadImg} />
      <p>만족스럽지 않나요? 【보정】을 클릭하면 Xiangji 공식 사이트로 이동해 계속 편집할 수 있어요.</p>
      <img alt="보정 클릭" decoding="async" loading="lazy" src={refine1} />
      <img alt="Xiangji 공식 사이트에서 보정" decoding="async" loading="lazy" src={refine2} />

      <h2>메인/상세 이미지 생성용 상품 이미지 수집 방법</h2>

      <h3>1. 상세 이미지 또는 메인 이미지를 생성할 상품 페이지를 열어 주세요</h3>
      <img alt="생성할 상품 페이지 열기" decoding="async" loading="lazy" src={listingOpen} />

      <h3>2. 상세 이미지 생성을 선택하고 상품 이미지를 수집하세요</h3>
      <p>확장 프로그램 아이콘이나 플로팅 위젯을 클릭해 【상세 이미지 생성】을 선택한 뒤 상품 이미지를 수집하세요.</p>
      <img alt="상세 이미지 생성 선택" decoding="async" loading="lazy" src={listingCollect} />
      <p>
        사용할 이미지를 선택하세요(상품 클로즈업 컷, 화이트 배경 컷, 각도 컷, 라이프스타일 컷). 이어서 【상세 이미지
        생성】을 클릭해요.
      </p>
      <img alt="사용할 상품 컷 선택" decoding="async" loading="lazy" src={listingSelect} />
      <p>
        【상세 이미지 생성】을 클릭하면 상품 정보와 선택한 이미지가 자동으로 분석되고, 몇 초 뒤 Xiangji 작업대로
        이동해요.
      </p>
      <img alt="상품 정보 분석 후 작업대로 이동" decoding="async" loading="lazy" src={listingParse} />
      <p>상품에 맞게 생성 설정을 완성하세요.</p>
      <img alt="생성 설정 완성" decoding="async" loading="lazy" src={listingSettings} />
      <p>
        아주 짧은 시간 안에 미리보기 세트가 생성되어 스타일과 효과를 확인할 수 있어요. 만족스럽지 않으면 다시 생성하고,
        만족스러우면 최종 고해상도 이미지 생성을 클릭하면 돼요.
      </p>
      <img alt="미리보기 세트" decoding="async" loading="lazy" src={listingPreview} />

      <h3>3. 다운로드</h3>
      <img alt="생성 결과 다운로드" decoding="async" loading="lazy" src={listingDownload} />
    </>
  );
};

export default KoContent;
